const adminDashboardHeader = {
	summary: "Summary",
	dashBoard: "Dashboard",
	all_group: "All Groups",
	create_group: "Create Group",
	edit_group: "Edit Group",
	view_group: "View Group",
	all_members: "All Members",
	all_group_members: "All Group Members",
	user_status: "User Status",
	employees: "Employees",
	document_administration: "Document Administration",
	upload_administration: "Upload Administration",
	my_profile: "My Profile",
	limit_groups: "Assign Group And Location",
	limit_locations: "Limit Locations",
	user_information: "User Information",
	edit_user_information: "Edit User Profile Information",
	health_links_group_assign: "Health Links Group Assign",
	blogs: "Blogs",
	edit_blogs: "Edit Blogs",
	add_blogs: "Add Blogs",
	claims: "Claims",
	announcements: "Announcements",
	add_announcements: "Add Announcement",
	edit_announcements: "Edit Announcement",
	group_assign: "Announcement Group Assign",
	announcement_limit_groups: "Announcement Limit Groups",
	location_assign: "Announcement Location Assign",
	employee_page_design: "Member Portal Page Design", // suggestion by abir
	notifications: "Notifications",
	create_user: "Create User",
	create_employee: "Create Employee",
	create_dependent: "Create Dependent",
	approve_dependent: "Approve Dependent",
	search_member: "Search Member",
	employee_mapping: "Employee Mapping",
	lincoln_enrollment_form: "Lincoln Enrollment Form",
	static_plan_creation: "Plan Creation",
	email_notification_managements: "Email Notifications Management",
	employer_dashboard: "Dashboard",
	employer_enrollment_approval: "Enrollment & Approval",
	employer_personal_change_request: "Personal Change Request",
	employer_waived_benefit: "Waived Benefits",
	dependent_change_request: "Dependent Change Request",
	employer_VEB_waived_benefit: "VEB Waived Benefits",
	user_management: "User Management",
	document_adminstration: "Document Adminstration",
	premium_recalculation: "Premium Recalculation And Validation",
	member_details: "Member Details",
	enrollment_details: "Enrollment Details",
	benefit_details: "Core Benefits Details",
	open_enrollment_lists: "Enrollment Lists",
	veb_benefit_details: "VEB Benefit Details",
	employment_details: "Employment Details",
	add_employment: "Add Employment Information",
	add_paycheck: "Add Paycheck Information",
	edit_employment: "Edit Employment",
	memeber_details: "Member Details",
	claim_details: "Claim Details",
	note_details: "Note Details",
	launch_enrollment: "Launch Enrollment",
	history: "History",
	open_enrollment: "Open Enrollment",
	VEB_open_enrollment: "VEB Open Enrollment",
	all_enrollments: "All Enrollments",
	all_VEB_enrollments: "All VEB Enrollments",
	add_location: "Add Location",
	all_locations: "All Locations",
	plan_management: "Plan Management",
	edit_location: "Edit Location",
	edit_profile: "Edit Profile Information",
	edit_contact: "Edit Contact Information",
	edit_dependent_profile: "Edit Dependent Profile Information",
	edit_dependent_contact: "Edit Dependent Contact Information",
	dependent_details: "Dependent Details",
	dependent_benefit_details: "Dependent Benefit Details",
	dependent_veb_benefit_details: "Dependent VEB Benefit Details",
	dependent_claim_details: "Dependent Claim Details",
	dependent_history: "Dependent History",
	reports: "Reports",
	report_management: "Report Management",
	census_report: "Census Report",
	location_employee_report: "Location Employee Report",
	dependent_report: "Dependent Report",
	total_deduction_report: "Total Deduction Report",
	plan_deduction_report: "Plan Deduction Report",
	veb_deduction_report: "VEB Deduction Report",
	veb_employment_terminated_report: "VEB Employment Terminated Report",
	benefit_changes_report: "Benefit Changes Report",
	employee_info_changes_report: "Employee Info Changes Report",
	personal_change_report: "Personal Change Report",
	employee_termination_report: "Employee Termination Report",
	member_bulk_upload: "Member Bulk Upload",
	member_bulk_location_number_upload: "Member Location Number Bulk Upload",
	member_bulk_text: "Member Bulk Text",
	single_text: "Send A Text",
	veb_termination_bulk_upload: "VEB Termination Bulk Upload",
	enroller_management: "Enroller Management",
	enroller_report_management: "Enroller Report Management",
	enroller_report: "VEB Enroller Report",
	group_agent_report: "Group Agent Report",
	check_date: "Check Date",
	open_enrollment_changes_report: "Open Enrollment Changes Report",
	wlt_comparison_report: "WLT Comparison Report",
	data_integrity_report_management: "Data Integrity Report Management",
	veb_empty_benefit_amount_report: "VEB Empty Benefit Amount Report",
	veb_empty_rider_benefit_amount_report: "VEB Empty Rider Benefit Amount Report",
	veb_invalid_sub_plan_report: "VEB Invalid Sub Plan Report",
	invalid_member_ssn_from_veb_enrollment_report: "Invalid Member SSN From VEB Enrollment Report",
	invalid_state_for_member_report: "Invalid State For member Report",
	invalid_zip_for_member_report: "Invalid ZIP For member Report",
	not_exist_member_location_report: "Not Exist For Member Location Report",
	active_group_plan_effective_date_null_report: "Active Group Plan Effective Date Null Report",
	veb_waived_benefits_report: "VEB Waived Benefits Report",
	active_paycheck_less_than_one_report: "Active Paycheck Less Than One Report",
	active_plan_for_employee_report: "Active Plan For Employee Report",
	remittance_report: "Remittance Report",
	veb_billing_report: "VEB Billing Report",
	active_paycheck_report: "Active Paycheck Report",
	dependent_more_than_26: "Dependent More Than Equal To 26 Years",
	member_info_update: "Member Info Update",
	member_email_updation: "Member Email Updation",
	member_SSN_updation: "Member SSN Updation",
	location_number_updation: "Location Number Updation",
	buy_up_eligibility: "Buy Up Eligibility Updation",
	hire_date_updation: "Hire Date Updation",
	date_of_birth_updation: "Date of Birth Updation",
	active_health_plan_and_clinic_card_for_member: "Active Health Plan And Clinic Card For Member Report",
	member_settings: "Member Settings",
	member_change_password: "Member Change Password",
	edit_member_settings: "Edit Member Settings",
	member_activity_logs: "Member Activity Logs",
	dependent_activity_logs: "Dependent Activity Logs",
	dependent_settings: "Dependent Settings",
	providers: "Providers",
	add_providers: "Add New Provider",
	provider_details: "Provider Details",
	add_providers_bulk_upload: "Providers Bulk Upload",
	update_providers_by_tax_id: "Update Providers (By Tax-ID)",
	edit_providers: "Edit Provider",
	core_group_agent_report: "Core Group Agent Report",
	core_enroller_report: "Core Enroller Report",
	core_active_enrollment_for_yoe: "Core Active Enrollment For YOE",
	veb_active_enrollment_for_yoe: "VEB Active Enrollment For YOE",
	previously_active_currently_waived: "Core Previously Active Currently Waived",
	veb_previously_active_currently_waived: "VEB Previously Active Currently Waived",
	core_weekly_premium_change_report: "Core Weekly Premium Change Report",
	core_monthly_premium_change_report: "Core Monthly Premium Change Report",
	veb_weekly_premium_change_report: "VEB Weekly Premium Change Report",
	veb_monthly_premium_change_report: "VEB Monthly Premium Change Report",
	core_action_taken_or_not_taken_yoe_report: "Core Action Taken or Not Taken for YOE Report",
	veb_action_taken_or_not_taken_yoe_report: "VEB Action Taken or Not Taken for YOE Report",
	health_plan_recalculation: "Health Plan Premium Recalculation And Validation",
	clinic_card_plan_recalculation: "Clinic Card Premium Recalculation And Validation",
	group_short_term_disability: "Group Short Term Disability Premium Recalculation And Validation",
	group_long_term_disability: "Group Long Term Disability(Class 2) Premium Recalculation And Validation",
	claim_status_v2: "Claim Status v2"
};

export const ADMIN_DASHBOARD_HEADER = adminDashboardHeader;
